<template>
    <div class="commodityInfo">
        <titles name="订单详情"></titles>
        <div class="content" v-for="(el, index) in item.commoditys" :key="index">
            <p class="m-b-27">{{el.commodityName}}</p>
            <div class="flex-row contentInfo">
                <div>{{el.commodityMaterial}}、{{el.commodityColour}}</div>
                <div>x{{el.commoditySize}}</div>
            </div>
        </div>
        <div class="gift" v-for="(el, index) in item.gifts" :key="index">
            <p class="giftTitle">赠品信息</p>
            <p class="m-b-27">{{el.giftName}}</p>
            <div class="flex-row contentInfo">
                <div> </div>
                <div>x{{el.giftSize}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
export default {
    components:{
        titles
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    
}
</script>
<style lang="scss" scoped>
    .commodityInfo{
        background: $ffff;
.content{
        margin: 0 20px;
        font-size:24px;
        color: $color-51;
        padding: 15px 0 17px 0;
        border-bottom: 1px solid rgba(230,230,230,1);
        p{
            margin-left: 56px;
        }
    }
    .total{
        padding: 25px 37px 17px 0 ;
        p{
            font-size:24px;
            color: $color-51;  
            text-align: right; 
            span{
                color: $color-36;
            }    
        }
    }
}
.contentInfo{
    margin: 0 38px 0 55px;
    justify-content: space-between;
}
.gift{
    font-size:26px;
    font-weight:400;
    color:rgba(51,51,51,1);
    padding-bottom:14px;
    border-bottom: 1px solid rgba(230,230,230,1);
    .giftTitle{
        margin: 23px 0 29px 39px; 
    }
}
</style>

